var HtmlComponent_default = {
  "htmlComponent": "-Cv-f",
  "htmlComponent_placeholder": "q6dNd"
};
export {
  HtmlComponent_default as default
};
//# sourceMappingURL=HtmlComponent-scss.js.map
